import React, {
  useEffect,
  useMemo,
} from 'react';
import {
  FieldComponentProps,
} from 'components/anvilFormFillable/fields/types';
import dynamic from 'next/dynamic';
import dayjs, {
  Dayjs,
} from 'dayjs';
import {
  formatDate,
  isEmptyString,
} from 'utils/helper';
import {
  getOrgNow,
} from 'utils/dayjs';
import clsx from 'clsx';
import isNil from 'lodash/isNil';

const MuiDatePicker = dynamic(() => import('components/common/datePicker'), { ssr: false });

export default function Date({
  field,
  value,
  onChange,
  error = false,
}: FieldComponentProps) {
  const isSignatureDate = field.type === 'signatureDate';

  const updateDate = (date: Dayjs | null) => {
    const formatted = !isNil(date) ? formatDate(date?.toDate()) : '';
    onChange({ ...value, value: formatted });
  };

  useEffect(() => {
    if (isSignatureDate && isEmptyString(value?.value)) {
      updateDate(getOrgNow());
    }
  }, [isSignatureDate, value?.value]);

  const date = useMemo(() => (
    isEmptyString(value?.value) ? undefined : dayjs(value.value as string)
  ), [value?.value]);

  return (
    <MuiDatePicker
      key={field.id}
      value={date}
      error={!isSignatureDate && error}
      autoFocus
      disabled={isSignatureDate}
      onChange={updateDate}
      className={clsx('w-full', { 'bg-[#e9edf4]': isSignatureDate })}
    />
  );
}
